module.exports = __webpack_public_path__ + "images/logo-78bc29d6.png";